import { getColourForEnvironment, getEnvironment } from "../services/environment"

export const zoneColourIcon = (zone: string): string => {
  if (zone?.startsWith('blue-')) {
    return '🔵'
  } else if (zone?.startsWith('red-')) {
    return '🔴'
  }
  return '❓'
}

export const zoneColourText = (zone: string): string => {
  if (zone?.startsWith('blue-')) {
    return '*** BLUE ***'
  } else if (zone?.startsWith('red-')) {
    return '--- RED ---'
  }
  return 'UNKNOWN'
}

export const zIndexPriorities = Array(22)
  .fill(0)
  .map((_, i) => {
    if (i < 20) {
      // Original range: 350 down to 331
      return -i + 350;
    } else {
      // Just 2 more levels: 1000 and 999 (above most UI but below modals)
      return -i + 1020;
    }
  });

// Named consts for high-priority elements
export const Z_INDEX_PRIORITIES = {
  PRIORITY_2_UI: 21,      // zIndex 999 - highest priority for hovered elements
  PRIORITY_1_UI: 20,    // zIndex 1000 - for important UI overlays
} as const;

export const indexPriority = (priority: number) => {
  // The lower the number the higher the priority
  return zIndexPriorities?.[priority] || 300;
};

export const geofenceColor = (id: string): string => {
  if (id === 'ad11d574-9ed6-4c76-927b-b6ebe81b5b75') {
    return '#FF6666';
  } else if (id === '0f51f506-7df8-4372-8400-3e8ed6eafd35') {
    return '#66CCFF';
  }
  return 'lightblue';
};

export const getHeaderBackgroundColor = (): string => {
  if (['dev', 'uat'].includes(getEnvironment())) {
    return `bg-${getColourForEnvironment()}-50`;
  }
  return `bg-${getColourForEnvironment()}`;
}
